/* ============================================================
   Véloria Piercing — Cart Drawer v3.0
   ============================================================ */

(function () {
  'use strict';

  console.log('[VCD] v3 chargé ✓');

  /* ── Helpers ── */
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }

  /* ── Détection d'un formulaire ATC Shopify ── */
  function isCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('cart/add') !== -1
      || !!form.querySelector('[name="form_type"][value="product"]');
  }

  /* ════════════════════════════════════════════════════════
     INTERCEPTION GLOBALE — STRATÉGIE 1
     S'enregistre IMMÉDIATEMENT à l'exécution du script.
  ════════════════════════════════════════════════════════ */
  document.addEventListener('submit', function (e) {
    if (!isCartForm(e.target)) return;
    console.log('[VCD] ✓ submit intercepté (global capture) — form:', e.target.id || e.target.getAttribute('action'));
    e.preventDefault();
    e.stopImmediatePropagation();
    var cd = window.VeloriaCartDrawer;
    if (cd) {
      cd._addFromForm(e.target);
    } else {
      console.warn('[VCD] VeloriaCartDrawer non prêt, retry…');
      var form = e.target;
      setTimeout(function () {
        var cd2 = window.VeloriaCartDrawer;
        if (cd2) cd2._addFromForm(form);
      }, 200);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!isCartForm(form)) return;
    console.log('[VCD] ✓ click ATC intercepté (global capture) — form:', form.id || form.getAttribute('action'));
    e.preventDefault();
    e.stopImmediatePropagation();
    var cd = window.VeloriaCartDrawer;
    if (cd && !cd._adding) {
      cd._addFromForm(form);
    } else if (!cd) {
      console.warn('[VCD] VeloriaCartDrawer non prêt au clic');
    }
  }, true);

  /* ── Ouverture drawer via icône panier ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vcd-open]');
    if (!btn) return;
    e.preventDefault();
    var cd = window.VeloriaCartDrawer;
    if (cd) cd.open();
  });

  /* ════════════════════════════════════════════════════════
     CLASSE CART DRAWER
  ════════════════════════════════════════════════════════ */
  function VeloriaCartDrawer() {
    this.drawer   = qs('#vcd-drawer');
    this.overlay  = qs('#vcd-overlay');
    this.body     = qs('#vcd-body');
    this.footer   = qs('#vcd-footer');
    this.toast    = qs('#vcd-added-toast');
    this.errToast = qs('#vcd-error-toast');

    this.cart         = null;
    this._adding      = false;
    this.discountCode = sessionStorage.getItem('vcd_discount') || '';
    this.noteDebounce = null;
    this._toastTimer  = null;
    this._errTimer    = null;

    this._readSettings();

    if (!this.drawer) {
      console.warn('[VCD] ⚠ #vcd-drawer introuvable dans le DOM. Vérifiez :\n  1. veloria-cart-drawer.liquid est dans theme/snippets/\n  2. veloria-header.liquid contient : {%- render "veloria-cart-drawer" -%}\n  3. Pas d\'erreur Liquid dans le header.');
      return;
    }

    console.log('[VCD] #vcd-drawer trouvé ✓');
    this._bindDrawer();
  }

  /* ── Settings depuis data-* du drawer ── */
  VeloriaCartDrawer.prototype._readSettings = function () {
    var d = this.drawer ? this.drawer.dataset : {};
    this.settings = {
      autoOpen:           d.autoOpen        !== 'false',
      shippingEnabled:    d.shipping        !== 'false',
      shippingFree:       d.shippingFree    === 'true',
      shippingThreshold:  parseFloat(d.shippingThreshold || '0') * 100,
      shippingTextBefore: d.shippingBefore  || 'Plus que [[amount]] pour la livraison offerte',
      shippingTextAfter:  d.shippingAfter   || 'Livraison suivie offerte',
      shippingFlatText:   d.shippingFlatText || '',
      shippingFlatCost:   Math.round(parseFloat(d.shippingFlatCost || '0') * 100),
      progressEnabled:    d.progress        !== 'false',
      progressGoal:       parseInt(d.progressGoal  || '2'),
      progressFree:       parseInt(d.progressFree  || '1'),
      progressMsg0:       d.progressMsg0    || 'Ajoutez [n] bijoux pour débloquer le [f]ème offert.',
      progressMsg1:       d.progressMsg1    || 'Plus que [n] bijou pour débloquer votre offre.',
      progressMsgDone:    d.progressMsgDone || 'Offre débloquée : ajoutez votre [f]ème bijou offert.',
      progressMsgFull:    d.progressMsgFull || 'Votre offre 2+1 est prête.',
      promoEnabled:       d.promo           !== 'false',
      noteEnabled:        d.note            !== 'false',
      urgencyEnabled:     d.urgency         !== 'false',
      giftEnabled:        d.gift            === 'true',
      giftVariantId:      d.giftVariant     || '',
      upsellEnabled:      d.upsell          !== 'false',
      addedText:          d.addedText       || '✓ Produit ajouté au panier',
      checkoutTxt:        d.checkoutTxt     || 'Valider ma commande',
    };
  };

  /* ── Événements internes du drawer ── */
  VeloriaCartDrawer.prototype._bindDrawer = function () {
    var self = this;

    on(qs('#vcd-close'),    'click', function () { self.close(); });
    on(this.overlay,        'click', function () { self.close(); });
    on(qs('#vcd-continue'), 'click', function () { self.close(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.drawer && self.drawer.classList.contains('is-open')) self.close();
    });

    /* Qty + remove — délégation */
    on(this.body, 'click', function (e) {
      var qBtn = e.target.closest('[data-vcd-qty]');
      if (qBtn) {
        var key   = qBtn.dataset.key;
        var delta = parseInt(qBtn.dataset.vcdQty);
        var item  = self.cart && self.cart.items.find(function (i) { return i.key === key; });
        if (item) self._updateQty(key, item.quantity + delta, qBtn.closest('.vcd__item'));
      }
      var rBtn = e.target.closest('[data-vcd-remove]');
      if (rBtn) self._updateQty(rBtn.dataset.vcdRemove, 0, rBtn.closest('.vcd__item'));

      /* Upsell add */
      var uBtn = e.target.closest('[data-vcd-upsell-add]');
      if (uBtn) {
        uBtn.classList.add('is-loading');
        self._addVariant(uBtn.dataset.vcdUpsellAdd, 1).finally(function () {
          uBtn.classList.remove('is-loading');
        });
      }

      /* Promo remove */
      if (e.target.closest('#vcd-promo-remove')) {
        self.discountCode = '';
        sessionStorage.removeItem('vcd_discount');
        self._renderPromoState();
      }
    });

    /* Promo toggle */
    var promoToggle = qs('#vcd-promo-toggle');
    var promoForm   = qs('#vcd-promo-form');
    on(promoToggle, 'click', function () {
      if (!promoForm) return;
      var open = promoForm.classList.toggle('is-open');
      promoToggle.setAttribute('aria-expanded', String(open));
    });
    on(qs('#vcd-promo-apply'), 'click',   function () { self._applyPromo(); });
    on(qs('#vcd-promo-input'), 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); self._applyPromo(); }
    });

    /* Note toggle */
    var noteToggle = qs('#vcd-note-toggle');
    var noteWrap   = qs('#vcd-note-wrap');
    on(noteToggle, 'click', function () {
      if (!noteWrap) return;
      var open = noteWrap.classList.toggle('is-open');
      noteToggle.setAttribute('aria-expanded', String(open));
    });
    var noteArea = qs('#vcd-note-area');
    on(noteArea, 'input', function () {
      clearTimeout(self.noteDebounce);
      self.noteDebounce = setTimeout(function () { self._saveNote(noteArea.value); }, 700);
    });

    /* Gift */
    on(qs('#vcd-gift-btn'), 'click', function () { self._toggleGift(); });
  };

  /* ── Open ── */
  VeloriaCartDrawer.prototype.open = function () {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.drawer.setAttribute('aria-hidden', 'false');
    var closeBtn = qs('#vcd-close');
    if (closeBtn) closeBtn.focus();
    this.fetchAndRender();
    document.dispatchEvent(new CustomEvent('vcd:opened'));
  };

  /* ── Close ── */
  VeloriaCartDrawer.prototype.close = function () {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    this.drawer.setAttribute('aria-hidden', 'true');
  };

  /* ── Fetch /cart.js ── */
  VeloriaCartDrawer.prototype.fetchCart = async function () {
    var r = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    if (!r.ok) throw new Error('Cart fetch failed');
    this.cart = await r.json();
    return this.cart;
  };

  VeloriaCartDrawer.prototype.fetchAndRender = async function () {
    try {
      await this.fetchCart();
      this._renderAll();
    } catch (err) {
      console.error('[VCD]', err);
    }
  };

  /* ── Ajouter depuis formulaire ── */
  VeloriaCartDrawer.prototype._addFromForm = async function (form) {
    if (this._adding) return;
    this._adding = true;
    console.log('[VCD] _addFromForm → envoi /cart/add.js');

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn._origText = btn.textContent; btn.textContent = '…'; }

    try {
      var fd = new FormData(form);
      var r  = await fetch('/cart/add.js', { method: 'POST', body: fd });
      if (!r.ok) { var err = await r.json(); throw new Error(err.description || 'Erreur'); }
      await this.fetchCart();
      this._renderAll();
      this._updateHeaderCount();
      this._showAddedToast();
      if (this.settings && this.settings.autoOpen) this.open();
      console.log('[VCD] produit ajouté ✓');
    } catch (err) {
      console.error('[VCD] erreur ajout:', err.message);
      this._showError(err.message || "Impossible d'ajouter ce produit.");
    } finally {
      this._adding = false;
      if (btn) { btn.disabled = false; btn.textContent = btn._origText || 'Ajouter au panier'; }
    }
  };

  /* ── Ajouter par variant id ── */
  VeloriaCartDrawer.prototype._addVariant = async function (variantId, qty) {
    var r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 }),
    });
    if (!r.ok) { var err = await r.json(); throw new Error(err.description || 'Erreur'); }
    await this.fetchCart();
    this._renderAll();
    this._updateHeaderCount();
    this._showAddedToast();
  };

  /* ── Modifier quantité ── */
  VeloriaCartDrawer.prototype._updateQty = async function (key, newQty, itemEl) {
    if (itemEl) itemEl.classList.add('is-loading');
    try {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, newQty) }),
      });
      if (!r.ok) throw new Error('update failed');
      this.cart = await r.json();
      if (newQty <= 0 && itemEl) {
        itemEl.classList.add('is-removing');
        await new Promise(function (res) { setTimeout(res, 250); });
      }
      this._renderAll();
      this._updateHeaderCount();
    } catch (err) {
      if (itemEl) itemEl.classList.remove('is-loading');
      this._showError('Impossible de mettre à jour le panier.');
    }
  };

  /* ── Note ── */
  VeloriaCartDrawer.prototype._saveNote = async function (note) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note }),
    });
  };

  /* ── Code promo ── */
  VeloriaCartDrawer.prototype._applyPromo = function () {
    var input = qs('#vcd-promo-input');
    if (!input) return;
    var code = input.value.trim().toUpperCase();
    if (!code) return;
    this.discountCode = code;
    sessionStorage.setItem('vcd_discount', code);
    this._renderPromoState();
  };

  VeloriaCartDrawer.prototype._renderPromoState = function () {
    var badge  = qs('#vcd-promo-badge');
    var msg    = qs('#vcd-promo-msg');
    var input  = qs('#vcd-promo-input');
    var form   = qs('#vcd-promo-form');
    var toggle = qs('#vcd-promo-toggle');
    if (!badge) return;

    if (this.discountCode) {
      badge.style.display = 'inline-flex';
      var codeSpan = badge.querySelector('[data-vcd-promo-code]');
      if (codeSpan) codeSpan.textContent = this.discountCode;
      if (msg)    { msg.style.display = 'block'; msg.className = 'vcd__promo-msg is-visible vcd__promo-msg--success'; }
      if (form)   form.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (input)  input.value = '';
    } else {
      badge.style.display = 'none';
      if (msg) msg.style.display = 'none';
    }
    this._updateCheckoutUrl();
  };

  VeloriaCartDrawer.prototype._updateCheckoutUrl = function () {
    var btn = qs('#vcd-checkout-btn');
    if (!btn) return;
    btn.href = this.discountCode
      ? '/checkout?discount=' + encodeURIComponent(this.discountCode)
      : '/checkout';
  };

  /* ── Gift ── */
  VeloriaCartDrawer.prototype._toggleGift = async function () {
    var vid = this.settings && this.settings.giftVariantId;
    if (!vid) return;
    var existing = this.cart && this.cart.items.find(function (i) { return String(i.variant_id) === String(vid); });
    if (existing) { await this._updateQty(existing.key, 0); }
    else           { await this._addVariant(vid, 1); }
    this._renderGiftState();
  };

  VeloriaCartDrawer.prototype._renderGiftState = function () {
    var btn = qs('#vcd-gift-btn');
    if (!btn) return;
    var vid    = this.settings && this.settings.giftVariantId;
    var inCart = this.cart && this.cart.items.find(function (i) { return String(i.variant_id) === String(vid); });
    btn.textContent = inCart ? '✓ Ajouté' : 'Ajouter';
    btn.classList.toggle('is-added', !!inCart);
  };

  /* ── Compteur header ── */
  VeloriaCartDrawer.prototype._updateHeaderCount = function () {
    var count = (this.cart && this.cart.item_count) || 0;

    /* Notre propre badge */
    document.querySelectorAll('[data-vcd-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });

    /* Compteur cart-bubble du thème — tous variants desktop + mobile */
    document.querySelectorAll('[ref="cartBubble"], .cart-bubble, [data-testid="cart-bubble"], .header__cart-count, .cart-count-bubble').forEach(function (bubble) {
      /* Trouver ou créer le span de comptage (pas le background) */
      var countSpan = bubble.querySelector('.cart-bubble__count, span:not(.cart-bubble__background)');
      if (!countSpan) {
        countSpan = document.createElement('span');
        countSpan.className = 'cart-bubble__count';
        bubble.appendChild(countSpan);
      }
      countSpan.textContent = count;
      bubble.style.display = count > 0 ? '' : 'none';
      /* Pulsation dorée quand le panier contient des articles */
      bubble.classList.toggle('vcd-pulse', count > 0);
    });

    /* Classe --has-cart sur l'icône panier native */
    document.querySelectorAll('cart-icon, [data-testid="cart-icon"]').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
  };

  /* ── Toast ajout ── */
  VeloriaCartDrawer.prototype._showAddedToast = function () {
    if (!this.toast) return;
    var msgEl = this.toast.querySelector('[data-vcd-toast-text]');
    if (msgEl && this.settings) msgEl.textContent = this.settings.addedText;
    this.toast.classList.add('is-visible');
    var self = this;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { self.toast.classList.remove('is-visible'); }, 2800);
  };

  /* ── Toast erreur ── */
  VeloriaCartDrawer.prototype._showError = function (msg) {
    if (!this.errToast) return;
    this.errToast.textContent = msg;
    this.errToast.classList.add('is-visible');
    var self = this;
    clearTimeout(this._errTimer);
    this._errTimer = setTimeout(function () { self.errToast.classList.remove('is-visible'); }, 4000);
  };

  /* ════════ RENDU ════════ */

  VeloriaCartDrawer.prototype._renderAll = function () {
    if (!this.cart || !this.drawer) return;
    var isEmpty = this.cart.item_count === 0;

    var emptyEl    = qs('#vcd-empty');
    var hasItemsEl = qs('#vcd-has-items');
    if (emptyEl)    emptyEl.style.display    = isEmpty ? '' : 'none';
    if (hasItemsEl) hasItemsEl.style.display = isEmpty ? 'none' : '';
    if (this.footer) this.footer.style.display = isEmpty ? 'none' : '';

    if (!isEmpty) {
      this._renderCount();
      this._renderShipping();
      this._renderProgress();
      this._renderItems();
      this._renderPromoState();
      this._renderSummary();
      this._renderGiftState();
      this._updateCheckoutUrl();
    }
  };

  VeloriaCartDrawer.prototype._renderCount = function () {
    var n  = this.cart.item_count;
    var el = qs('#vcd-header-count');
    if (el) el.textContent = n === 1 ? '1 article' : (n + ' articles');
  };

  VeloriaCartDrawer.prototype._renderShipping = function () {
    if (!this.settings || !this.settings.shippingEnabled) return;
    var msgEl    = qs('#vcd-shipping-msg');
    var barEl    = qs('#vcd-shipping-bar');
    var sumEl    = qs('#vcd-summary-shipping');
    if (!msgEl) return;
    var total     = this.cart.total_price;
    var threshold = this.settings.shippingThreshold;

    var summaryText = '';
    var summaryFree = false;

    if (this.settings.shippingFree) {
      msgEl.textContent = this.settings.shippingTextAfter;
      summaryText = 'Offerte';
      summaryFree = true;
    } else if (threshold <= 0) {
      msgEl.textContent = this.settings.shippingFlatText || this.settings.shippingTextAfter;
      summaryText = this.settings.shippingFlatText || this.settings.shippingTextAfter;
      summaryFree = false;
    } else if (total >= threshold) {
      msgEl.textContent = this.settings.shippingTextAfter;
      if (barEl) barEl.style.width = '100%';
      summaryText = 'Offerte';
      summaryFree = true;
    } else {
      msgEl.textContent = this.settings.shippingTextBefore.replace('[[amount]]', money(threshold - total));
      if (barEl) barEl.style.width = Math.min(100, (total / threshold) * 100) + '%';
      summaryText = 'Calculée au paiement';
      summaryFree = false;
    }

    if (sumEl) {
      sumEl.textContent = summaryText;
      sumEl.classList.toggle('vcd__summary-shipping--free', summaryFree);
    }
  };

  VeloriaCartDrawer.prototype._renderProgress = function () {
    if (!this.settings || !this.settings.progressEnabled) return;
    var msgEl = qs('#vcd-progress-msg');
    var barEl = qs('#vcd-progress-bar');
    if (!msgEl) return;
    var goal = this.settings.progressGoal;
    var free = this.settings.progressFree;
    var qty  = this.cart.item_count;
    var pct  = 0, msg = '';

    if (qty === 0) {
      msg = this.settings.progressMsg0.replace('[n]', goal).replace('[f]', free);
    } else if (qty < goal) {
      msg = this.settings.progressMsg1.replace('[n]', goal - qty).replace('[f]', free);
      pct = (qty / goal) * 100;
    } else if (qty === goal) {
      msg = this.settings.progressMsgDone.replace('[f]', free);
      pct = 100;
    } else {
      msg = this.settings.progressMsgFull;
      pct = 100;
    }
    msgEl.innerHTML = msg;
    if (barEl) barEl.style.width = pct + '%';
  };

  VeloriaCartDrawer.prototype._renderItems = function () {
    var container = qs('#vcd-items');
    if (!container || !this.cart) return;
    container.innerHTML = this.cart.items.map(this._itemHTML.bind(this)).join('');
  };

  VeloriaCartDrawer.prototype._itemHTML = function (item) {
    var imgTag = item.featured_image && item.featured_image.url
      ? '<img class="vcd__item-img" src="' + item.featured_image.url + '&width=160" alt="" loading="lazy" width="72" height="72">'
      : '<div class="vcd__item-img-placeholder" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';

    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="vcd__item-variant">' + this._esc(item.variant_title) + '</div>' : '';

    var compare = item.original_price > item.final_price
      ? '<span class="vcd__item-compare">' + money(item.original_price) + '</span>' : '';

    var linePrice = item.quantity > 1
      ? '<span class="vcd__item-line-price">' + money(item.final_line_price) + '</span>' : '';

    return '<div class="vcd__item" data-key="' + item.key + '" role="listitem">'
      + '<a href="' + item.url + '" tabindex="-1">' + imgTag + '</a>'
      + '<div class="vcd__item-body">'
      +   '<a href="' + item.url + '" class="vcd__item-title">' + this._esc(item.product_title || item.title) + '</a>'
      +   variant
      +   '<div class="vcd__item-price-row">'
      +     '<span class="vcd__item-price">' + money(item.final_price) + '</span>'
      +     compare + linePrice
      +   '</div>'
      +   '<div class="vcd__item-footer">'
      +     '<div class="vcd__qty" role="group" aria-label="Quantité">'
      +       '<button class="vcd__qty-btn" data-vcd-qty="-1" data-key="' + item.key + '" aria-label="Diminuer"' + (item.quantity <= 1 ? ' disabled' : '') + '>'
      +         '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/></svg>'
      +       '</button>'
      +       '<span class="vcd__qty-val" aria-live="polite">' + item.quantity + '</span>'
      +       '<button class="vcd__qty-btn" data-vcd-qty="1" data-key="' + item.key + '" aria-label="Augmenter">'
      +         '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
      +       '</button>'
      +     '</div>'
      +     '<button class="vcd__item-remove" data-vcd-remove="' + item.key + '" aria-label="Supprimer">'
      +       '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>'
      +     '</button>'
      +   '</div>'
      + '</div></div>';
  };

  VeloriaCartDrawer.prototype._renderSummary = function () {
    var el = qs('#vcd-subtotal');
    if (el && this.cart) el.textContent = money(this.cart.total_price);
    var totalEl = qs('#vcd-total');
    if (totalEl && this.cart) {
      var s = this.settings;
      var displayTotal = this.cart.total_price;
      if (s && !s.shippingFree && s.shippingThreshold <= 0 && s.shippingFlatCost > 0) {
        displayTotal += s.shippingFlatCost;
      }
      totalEl.textContent = money(displayTotal);
    }
    var promoRow = qs('#vcd-summary-promo');
    if (promoRow) {
      promoRow.style.display = this.discountCode ? '' : 'none';
      var codeEl = promoRow.querySelector('[data-vcd-promo-code-summary]');
      if (codeEl) codeEl.textContent = this.discountCode;
    }
  };

  VeloriaCartDrawer.prototype._esc = function (str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  /* ════════ UPSELL ════════ */
  function VeloriaCartUpsell(cd) {
    this.cd   = cd;
    this.wrap = qs('#vcd-upsell-wrap');
    if (!this.wrap) return;
    this.collectionUrl = this.wrap.dataset.collectionUrl || '/collections/best-sellers';
    var self = this;
    document.addEventListener('vcd:opened', function () { self._load(); });
  }

  VeloriaCartUpsell.prototype._load = async function () {
    var listEl = qs('#vcd-upsell-list', this.wrap);
    if (!listEl) return;
    try {
      var r = await fetch(this.collectionUrl + '/products.json?limit=6');
      if (!r.ok) { this.wrap.style.display = 'none'; return; }
      var data     = await r.json();
      var products = (data.products || []).slice(0, 4);
      if (!products.length) { this.wrap.style.display = 'none'; return; }
      listEl.innerHTML = products.map(this._cardHTML).join('');
      this.wrap.style.display = '';
    } catch (e) { this.wrap.style.display = 'none'; }
  };

  VeloriaCartUpsell.prototype._cardHTML = function (p) {
    var variant = p.variants && p.variants[0];
    if (!variant) return '';
    var imgUrl  = p.images && p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_160x160$1$2') : '';
    var price   = money(variant.price * 100);
    return '<div class="vcd__upsell-card">'
      + '<a href="/products/' + p.handle + '" class="vcd__upsell-img-wrap" tabindex="-1">'
      + (imgUrl ? '<img class="vcd__upsell-img" src="' + imgUrl + '" alt="' + p.title + '" loading="lazy">' : '<div class="vcd__upsell-img"></div>')
      + '</a><div class="vcd__upsell-body">'
      + '<a href="/products/' + p.handle + '" class="vcd__upsell-name">' + p.title + '</a>'
      + '<div class="vcd__upsell-price">' + price + '</div>'
      + '<button class="vcd__upsell-add" data-vcd-upsell-add="' + variant.id + '" aria-label="Ajouter ' + p.title + '">'
      + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Ajouter'
      + '</button></div></div>';
  };

  /* ════════════════════════════════════════════════════════
     INIT — STRATÉGIE 2 : liaison directe sur les formulaires
     Après DOMContentLoaded, on trouve chaque form ATC dans le
     DOM et on y ajoute un listener capture direct (backup).
  ════════════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {

    /* ── Neutraliser le cart drawer natif du thème ── */
    var themeDrawer = document.querySelector('cart-drawer-component, cart-drawer, #CartDrawer');
    if (themeDrawer) {
      /* Supprimer auto-open seulement — ne pas masquer (l'icône panier est à l'intérieur) */
      themeDrawer.removeAttribute('auto-open');

      /* Écraser la méthode open() du web component pour rediriger vers notre drawer */
      themeDrawer.open = function () {
        var cd = window.VeloriaCartDrawer;
        if (cd) cd.open();
      };

      /* Surveiller les tentatives d'ouverture via attributs/classes */
      var _vcdObs = new MutationObserver(function () {
        var isOpen = themeDrawer.hasAttribute('open')
          || themeDrawer.classList.contains('is-open')
          || themeDrawer.classList.contains('open')
          || themeDrawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          themeDrawer.removeAttribute('open');
          themeDrawer.classList.remove('is-open', 'open');
          themeDrawer.setAttribute('aria-hidden', 'true');
          var cd = window.VeloriaCartDrawer;
          if (cd) cd.open();
        }
      });
      _vcdObs.observe(themeDrawer, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });

      console.log('[VCD] Cart drawer natif neutralisé ✓');
    }

    /* Diagnostic DOM */
    var atcForms = document.querySelectorAll('form[action*="cart/add"]');
    console.log('[VCD] DOMContentLoaded — formulaires ATC dans le DOM:', atcForms.length);

    atcForms.forEach(function (form) {
      console.log('[VCD]   → form#' + (form.id || '(sans id)') + ' action=' + form.getAttribute('action'));

      /* Liaison directe capture phase sur la form (stratégie 2) */
      form.addEventListener('submit', function (e) {
        console.log('[VCD] ✓ submit intercepté (direct form capture)');
        e.preventDefault();
        e.stopImmediatePropagation();
        var cd = window.VeloriaCartDrawer;
        if (cd) cd._addFromForm(form);
      }, true);
    });

    /* Instanciation du drawer */
    var cd = new VeloriaCartDrawer();
    window.VeloriaCartDrawer = cd;
    console.log('[VCD] Drawer initialisé. #vcd-drawer:', cd.drawer ? 'trouvé ✓' : 'MANQUANT ✗');

    new VeloriaCartUpsell(cd);

    /* Initialiser le compteur + animation dès le chargement de page */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cd.cart = cart;
        cd._updateHeaderCount();
      })
      .catch(function () {});
  });

})();
